import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { category } from "../../types/modules/Category";
import { SubCategory } from "../../types/modules/SubCategory";

export const useCategories = () => {
  return useQuery({
    queryKey: ["categories"],
    queryFn: () => fetcher<category[]>(`type/all`),
  });
};

export const useSubCategoriesByCategory = (
  categoryId: number | null | undefined
) => {
  return useQuery({
    queryKey: ["subcategories-by-category", categoryId],
    queryFn: () =>
      categoryId
        ? fetcher<SubCategory[]>(`subtype/byType/${categoryId}`)
        : Promise.resolve([]),
    enabled: true, // always enabled so it returns [] if no categoryId
  });
};
